import React, {useEffect, useState} from 'react';
import styles from './Theme.module.scss'
import {Preloader, useToast} from "uikit";
import CheckIcon from '@/assets/images/icons/16/check.svg'
import {GeneralMethods} from "@/views/Admin/Events/Event/General/General.methods";
import {useSelector} from "react-redux";
import {useRouteMatch} from "react-router-dom";

const Theme = () => {
    const {patchEventParams} = GeneralMethods
    const toast = useToast()
    const {theme_form} = useSelector((state: any) => state.admin.event)
    const match = useRouteMatch()
    const eventId = match.params.id

    useEffect(() => {
        handleGetData()
    }, [theme_form]);

    const handleGetData = () => {
        if (theme_form === undefined) return;

        setData(prev => prev.map(x => x.id === theme_form ? {...x, isActive: true} : x))
    }

    const [data, setData] = useState([
        {
            srcSet: '/assets/images/form/light.webp',
            src: '/assets/images/form/light.png',
            alt: 'Светлый дизайн формы продажи',
            title: 'Светлый',
            type: 'image/webp',
            id: 0,
            isActive: false,
            isLoading: false,
            isDisabled: false,
        },
        {
            srcSet: '/assets/images/form/dark.webp',
            src: '/assets/images/form/dark.png',
            alt: 'Темный дизайн формы продажи',
            title: 'Темный',
            type: 'image/webp',
            id: 1,
            isActive: false,
            isLoading: false,
            isDisabled: false,
        },
        {
            srcSet: '/assets/images/form/auto.webp',
            src: '/assets/images/form/auto.png',
            alt: 'Автоматический дизайн формы продажи',
            title: 'Автоматически',
            type: 'image/webp',
            id: 2,
            isActive: false,
            isLoading: false,
            isDisabled: false,
        }
    ])

    const handleChange = async (id: Number) => {
        setData(prev => prev.map(x => x.id === id ? {...x, isLoading: true} : x).map(x => ({...x, isDisabled: true})))
        try {
            await patchEventParams('events', eventId, {themeForm: id});
            setData(prev => prev.map(x => x.id === id ? {...x, isActive: true} : {...x, isActive: false}))
        } catch (error) {
            console.error(error)
            toast({message: 'Произошла ошибка', type: 'danger', duration: 3000});
        } finally {
            setData(prev => prev.map(x => ({...x, isLoading: false, isDisabled: false})))
        }
    }

    return (
        <div className={'ui-cp__container'}>
            <div className="ui-cp__row ui-cp__row_md">
                <div className="ui-cp__form">
                    <h4 className={'settings-main-title'}>
                        Дизайн формы регистрации
                    </h4>
                    {theme_form !== undefined ? <div className={styles.container}>
                        {data.map(({srcSet, src, alt, type, title, id, isActive, isLoading, isDisabled}) => <div
                            key={id}
                            className={[
                                styles.item,
                                isActive && styles.isActive,
                                isDisabled && styles.isDisabled,
                            ].filter(Boolean).join(' ')}
                            onClick={() => handleChange(id)}>
                            <span className={[
                                styles.isPreloader,
                                isLoading && styles.isLoading
                            ].filter(Boolean).join(' ')}>
                                <Preloader/>
                            </span>
                            <span className={styles.icon}>
                                <CheckIcon/>
                            </span>
                            <picture>
                                <source srcSet={srcSet} type={type}/>
                                <img src={src} alt={alt}/>
                            </picture>
                            <h6 className={styles.title}>
                                {title}
                            </h6>
                        </div>)}
                    </div> : <Preloader/>}
                </div>
            </div>
        </div>
    );
};

export default Theme;
